import type { ContextKey } from '@/types/FieldConfig'

import type { IconProps } from '@/components/ui/icon'

export interface ContextDescriptor {
  ctx: ContextKey;
  icon: IconProps['name'];
  label: string;
  shortLabel: string;
}

/**
 * The three places a field can appear, named after where a person meets it rather
 * than after the context key the backend stores.
 */
const contexts: ContextDescriptor[] = [
  { ctx: 'backoffice', icon: 'LayoutDashboard', label: 'Backoffice', shortLabel: 'Backoffice' },
  { ctx: 'public', icon: 'Globe', label: 'Online form', shortLabel: 'Online' },
  { ctx: 'mobileApp', icon: 'Smartphone', label: 'Mobile app', shortLabel: 'App' },
]

export default contexts
